module.exports = __webpack_public_path__ + "static/media/IMG_7795.6e472e3f.JPG";